import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllGift,
  Status,
} from "../../../../features/admin/gift_management/user_gift/Slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = React.useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const gift = useSelector((state) => state.gift_managements.user_gift);

  const [name, setName] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [type, setType] = useState("");

  useEffect(() => {
    fetch();
  }, [name, type, contactNo]);

  const fetch = async (page = gift?.current_page) => {
    // await dispatch(Allgift());
    await dispatch(
      GetAllGift({
        name: name,
        type: type,
        contactNo: contactNo,
        page: page,
        per_page: gift?.per_page,
      }),
    );
  };

  const toggleStatus = async (id) => {
    try {
      const res = await dispatch(Status(id));
      if (res.payload?.data?.success) {
        await fetch();
        setModalShow(true);
        return true;
      }
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  return {
    gift,
    name,
    setName,
    fetch,
    modalMessage,
    modalShow,
    setModalShow,
    setType,
    type,
    toggleStatus,
    contactNo,
    setContactNo,
  };
};
